import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { getIntegrationSettingsSchema } from './schema'
import { useZocksQuota } from '../../../../components/ScopedBlock/hooks'
// 👇 IMPORT YOUR ZOD SCHEMA HERE

export const DebugZodErrors: React.FC<{ shouldDebug?: boolean }> = ({ shouldDebug = false }) => {
  const {
    watch,
    formState: { isValid },
  } = useFormContext()
  const values = watch()
  const { getQuotaValue } = useZocksQuota()
  const additionalObjectsLimit = getQuotaValue('integration.additionalObjMax.value')

  useEffect(() => {
    if (!shouldDebug) {
      return
    }
    if (!isValid) {
      console.group('🕵️ MANUAL ZOD VALIDATION CHECK')

      // Force Zod to parse the current form data
      const result = getIntegrationSettingsSchema(additionalObjectsLimit as number).safeParse(values)

      if (!result.success) {
        console.error('🚨 REAL REASON FOR INVALID STATE:')
        // .format() makes the error easier to read than the standard Zod error
        console.log(result.error.format())
      } else {
        console.log('✅ Zod says the data is VALID. (RHF might be stuck in a stale state)')
      }

      console.groupEnd()
    }
  }, [values, isValid, shouldDebug, additionalObjectsLimit])

  return null
}
